import httpClient from './httpClient';
const prefix = 'workplace';

export default {
  async getAll(params) {
    const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getAll`, { params });
    return data;
  },
  async getById(id) {
    const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getById/${id}`);
    return data;
  },
  async getAllByCompany() {
    const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getAllByCompany`);
    return data;
  },
  async create(body) {
    const response = await httpClient({ requiresAuth: true }).post(`${prefix}/create`, body);
    return response;
  },
  async update(body, id) {
    const response = await httpClient({ requiresAuth: true }).put(`${prefix}/update/${id}`, body);
    return response;
  },
  async delete(id) {
    const response = await httpClient({ requiresAuth: true }).delete(`${prefix}/delete/${id}`);
    return response;
  }
}